module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_movilidad_personal.78021dd2.jpg";